// Module
var code = `<div id="error-modal" class="modal-dialog" role="document">
	<div class="modal-content">
		<div class="modal-header">
			<h4 class="modal-title" data-bind="html: title"></h4>
		</div>
		<div class="modal-body">
			<ul class="lead list-unstyled card card-block" data-bind="foreach: errors">
				<li><i class="fa fa-exclamation-circle color-red"></i> <span data-bind="text: \$data"></span></li>
			</ul>
			<p class="lead text-muted" style="margin-bottom: 0">Please correct and try again.</p>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
		</div>
	</div>
</div>
`;
// Exports
export default code;